const XINTEL_URL = 'https://xintelapi.com.ar/';
const XINTEL_API_KEY = '4m17zq256jvsm24wOnqbev43y';
const XINTEL_INM = 'SSE';

// Manda el lead también al CRM de Xintel. Se dispara en paralelo al email de
// formsubmit.co y nunca bloquea ni rompe el envío del formulario: si Xintel
// falla, el usuario igual ve la confirmación porque el email sí salió.
const enviarLeadAXintel = (datos) => {
  const body = new URLSearchParams({
    json: 'consultas_web',
    apiK: XINTEL_API_KEY,
    inm: XINTEL_INM,
    codsuc: XINTEL_INM,
    desde: 'Pagina Web',
    nombre: datos.get('name') || '',
    apellido: datos.get('surname') || '',
    telefono: datos.get('phone') || '',
    email: datos.get('email') || '',
    comentario: datos.get('message') || datos.get('property_operation') || ''
  });

  fetch(XINTEL_URL, { method: 'POST', body }).catch((error) => {
    console.error('Error al enviar el lead a Xintel:', error);
  });
};

const Envio = (event) => {
  const formData = new FormData(event.target);

  enviarLeadAXintel(formData);

  return fetch("https://formsubmit.co/ajax/susanaespinoza.propiedades@gmail.com", {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Error en la solicitud");
      }
      // Devuelve true si la respuesta es exitosa (cualquier código de respuesta 2xx)
      return true;
    })
    .catch((error) => {
      console.error("Error al enviar el formulario:", error);
      // Devuelve false en caso de error
      return false;
    });
};

export default Envio;
